import { BlockProps, ProgramCardProps } from "@/utils/types";
import { ProgramCard } from "../modules/ProgramCard";
import { BlockWrapper } from "./BlockWrapper";
import { sanitize } from "@/utils/sanitize";
import { ProgramCardWide } from "../modules/ProgramCardWide";
import { Fragment } from "react";

interface ProgramsProps extends BlockProps {
  large?: boolean;
  items: ProgramCardProps[];
}

export const Programs = ({
  backgroundColor = "bg-white",
  bottom,
  className,
  colorStarter,
  componentId,
  heading,
  items,
  large,
  primaryEnder,
}: ProgramsProps) => {
  const lightMode =
    sanitize(backgroundColor) === "bg-white" ||
    sanitize(backgroundColor) === "pattern" ||
    sanitize(backgroundColor) === "bg-secondary" ||
    sanitize(backgroundColor) === "bg-tertiary";

  const blockProps = {
    backgroundColor,
    bottom,
    colorStarter,
    componentId,
    heading,
    lightMode,
    primaryEnder,
  };
  return (
    <BlockWrapper
      {...blockProps}
      className={`programs${className ? ` ${className}` : ""}`}
    >
      <div className="contained">
        <div
          className={`flex gap-8 justify-center flex-col${large ? "" : " md:flex-row flex-wrap"}${items?.length <= 2 ? " md:flex-nowrap" : ""}`}
        >
          {items?.map((item, index) => {
            return (
              <Fragment key={item?._id ? item._id + index : `program-${index}`}>
                {large ? (
                  <>{item && <ProgramCardWide {...item} />}</>
                ) : (
                  <>{item && <ProgramCard {...item} />} </>
                )}
              </Fragment>
            );
          })}
        </div>
      </div>
    </BlockWrapper>
  );
};
